import { render, staticRenderFns } from "./Motherboard.vue?vue&type=template&id=afcf9460"
import script from "./Motherboard.vue?vue&type=script&lang=js"
export * from "./Motherboard.vue?vue&type=script&lang=js"
import style0 from "./Motherboard.vue?vue&type=style&index=0&id=afcf9460&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports